import axios from 'axios';
import { message } from 'antd';
import Cookies from 'js-cookie';
import { AUTH_TOKEN_KEY } from 'src/constants';

// ?note: add this line to enable cookie manipulate
axios.defaults.withCredentials = true;

export async function request(options) {
  try {
    console.log(`[API] request: ${JSON.stringify(options, null, 2)}`);

    const shouldError = localStorage.getItem('isDebug');

    if (shouldError === 'true') {
      throw new Error('模擬錯誤');
    }

    const result = await axios(options);
    console.log(`[API] status: ${result?.status}`);

    return result;
  } catch (err) {
    console.log('error', err);
    const status = err?.response?.status;
    // const data = err?.response?.data;
    const msg = err?.message ?? err;

    const log = [
      status ? `status: ${status}` : null,
      // data ? `data: ${JSON.stringify(data)}` : null,
      msg ? `msg: ${msg}` : null
    ]
      .filter((el) => !!el)
      .join(', ');

    console.log(`[API] error ${log}`);

    // 處理 401 未授權錯誤，跳轉到登入頁
    if (status === 401) {
      console.log('[API] 401 Unauthorized - redirecting to login page');
      // 顯示友好的錯誤訊息
      message.error('登入已過期，請重新登入');
      // 清除 cookies 中的認證 token
      Cookies.remove(AUTH_TOKEN_KEY);
      // 延遲跳轉，讓用戶看到錯誤訊息
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
    }

    throw err;
  }
}

export const getHost = () => {
  // local
  if (/:\d{4,}$/.test(window.location.origin)) {
    const r = window.location.origin.split(/:\d{4,}/);
    if (r[0]) {
      return `${r[0]}:5000`;
    }
  }

  // dev
  if (/c3cf3/.test(window.location.host)) {
    return 'https://c3cf3.miraclemobile.com.tw';
  }

  // pro
  return '';
};

export const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'private'
  };
};
